import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CrmZone from '@swf/components/CrmZone/CrmZone';
import { CRMZone } from '@swf/core/enums';
import useTrackers from '@swf/core/hooks/useTrackers';
import type { Dispatch, RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import CookieNames from '@swf/core/types/Cookies';

import styles from './FloatingWelcomeOffer.scss';

interface Props {
  popupZoneId?: CRMZone;
  iconZoneId?: CRMZone;
}

const FloatingWelcomeOffer: React.FC<Props> = ({
  popupZoneId = CRMZone.WSL_WELCOME_OFFER_POPUP,
  iconZoneId = CRMZone.WSL_WELCOME_OFFER_ICON
}) => {
  const { CRMClicked } = useTrackers();
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const { contents: iconContents } = useSelector((rootState: RootState) =>
    select.crm.getZone(rootState, iconZoneId)
  );
  const { contents: popupContents } = useSelector((rootState: RootState) =>
    select.crm.getZone(rootState, popupZoneId)
  );
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    modal,
    crm: { fetchZone }
  } = useDispatch<Dispatch>();
  const cookieNotification = useSelector(select.notification.getCookies)[
    CookieNames.COOKIE_NOTIFICATION
  ];

  const onScroll = useCallback(() => {
    setIsScrolled(true);
    window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);

  useEffect(() => {
    fetchZone({ zoneId: iconZoneId as string });
    fetchZone({ zoneId: popupZoneId as string });
  }, [fetchZone, isAuthenticated, iconZoneId, popupZoneId]);

  return !cookieNotification &&
    !isAuthenticated &&
    iconContents?.length &&
    popupContents?.length &&
    isScrolled ? (
    <div
      className={styles.icon}
      role="button"
      onClick={(event: React.MouseEvent<HTMLDivElement>) => {
        CRMClicked(iconZoneId, iconContents[0], 'open_crm_modal');
        event.preventDefault();
        modal.enqueue({
          path: `/stars-crm/${popupZoneId}`,
          locationState: { zoneId: 'FLOATINGOFFER' }
        });
      }}
    >
      <CrmZone zoneId={iconZoneId} componentType="Single" />
    </div>
  ) : null;
};

export default FloatingWelcomeOffer;
